<div class="legs">
    @for (leg of optionGroupLegs; track $index) {
        <div class="market-leg">
            <div class="circle-overlay">
                <vn-icon name="theme-radio-off" [size]="isEpcotEnabled ? '8' : '10'" />
            </div>
            <span class="leg">{{ leg }}</span>
        </div>
    }
</div>

<div class="pre-created-option">
    <ms-betbuilder-group-pick
        class="pre-created-option-selectable"
        [event]="event"
        [eventOptionGroups]="eventOptionGroups"
        [betbuilderOptionGroup]="optionGroup.externalGroupInfo"
        [trackingSource]="pickTrackingSource"
        [class.disabled]="isSuspended"
        [sourceOfPick]="sourceOfPick">
        @if (isSuspended) {
            <div class="lock option-group-lock-icon">
                <vn-icon [name]="isEpcotEnabled ? 'theme-locked' : 'theme-locked-i'" [size]="isEpcotEnabled ? '16' : '14'" />
            </div>
        }
        @if (!isSuspended) {
            <ms-font-resizer [maxChars]="6" [value]="optionGroup.externalGroupInfo.builderOptionPricing.odds.odds | msNativePriceFormatter" />
        }
    </ms-betbuilder-group-pick>
</div>

@if (showSGPButtonsInPrebuiltSGP) {
    <ms-betbuilder-edit-pre-created-group-button
        [event]="event"
        [eventOptionGroups]="eventOptionGroups"
        [betbuilderOptionGroup]="optionGroup.externalGroupInfo"
        [class.disabled]="isSuspended" />
}
